import { Metrics } from '../../../../../../shared/theme';


export default {
  container: {
    width: '360px',
    color: '#393B46',
    padding: '8px 12px 8px 12px',
    boxShadow: '0px 4px 8px 0px #A7A9B729',
    borderRadius: '8px',
  },
  activeContainer: {
    backgroundColor: '#F5F5F5'
  },
  dayNameText: {
    paddingLeft: '16px'
  },
  hidden: {
    display: 'none'
  },
  spaceDate: {
    width: Metrics.triperBaseMargin
  },
  selectDateRow: {
    marginTop: '8px'
  },
  spaceStyle: {
    width: '100%',
  },
  unOccupiedFloatingLabel: {
    color: '#595959'
  },
  occupiedFloatingLabel: {
    background: 'linear-gradient(to bottom, #f5f5f5 50%, white 50%)',
  },
  timeDropdown: {
    width: '160px',
  },
}